import { render, staticRenderFns } from "./hwVerifyAddress.vue?vue&type=template&id=65296568&scoped=true&lang=pug&"
import script from "./hwVerifyAddress.vue?vue&type=script&lang=js&"
export * from "./hwVerifyAddress.vue?vue&type=script&lang=js&"
import style0 from "./hwVerifyAddress.vue?vue&type=style&index=0&id=65296568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65296568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65296568')) {
      api.createRecord('65296568', component.options)
    } else {
      api.reload('65296568', component.options)
    }
    module.hot.accept("./hwVerifyAddress.vue?vue&type=template&id=65296568&scoped=true&lang=pug&", function () {
      api.rerender('65296568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/dialog/hwVerifyAddress.vue"
export default component.exports